module.exports = __webpack_public_path__ + "static/media/view3.a74d3281.jpg";